/**
 * Лента просит расширение открыть вкладки контор.
 *
 * Chrome из одного жеста пускает одно `window.open`. На стриме 16.09 вторую
 * контору закрыл попап-блокер, и «открыть обе» открыла одну. У расширения
 * `chrome.tabs.create` этого запрета нет.
 *
 * Форма та же, что у обещания: лента кладёт сообщение в своё окно, мостик
 * слышит только его. Чужой iframe с чужим списком URL не проходит
 * `event.source !== window` на той стороне.
 */

export const OPEN_TABS = 'forq:open-tabs';

const HTTP = /^https?:\/\//i;

export function openTabsEnvelope(urls: readonly string[]): {
  channel: string;
  urls: string[];
} {
  return { channel: OPEN_TABS, urls: urls.filter((url) => HTTP.test(url)).slice(0, 4) };
}

export function parseOpenTabs(data: unknown): string[] | null {
  if (typeof data !== 'object' || data === null) return null;
  const body = data as { channel?: unknown; urls?: unknown };
  if (body.channel !== OPEN_TABS) return null;
  if (!Array.isArray(body.urls)) return null;
  const urls = body.urls.filter(
    (url): url is string => typeof url === 'string' && HTTP.test(url) && url.length < 2048,
  );
  return urls.length > 0 ? urls.slice(0, 4) : null;
}
